import { useState, useEffect } from 'react'

// B-868 · Mira el ANCHO EFECTIVO: la ventana dividida por el tamaño elegido en el perfil (un zoom en <html>, ver
// utils/uiScale). Con «Muy grande» en una pantalla de 1280 solo caben 1024 de CSS, y la app tiene que pasar a su diseño
// estrecho igual que con el zoom del navegador. Y se recalcula al cambiar el tamaño en el perfil (evento 'biango:zoom'),
// no solo al redimensionar. Sin import a propósito: varias guardias cargan este hook de verdad.
const anchoEfectivo = () => {
  let z = 1
  try { z = parseFloat(document.documentElement.style.zoom) || 1 } catch (_) { z = 1 }
  return window.innerWidth / z
}

export function useIsMobile(breakpoint = 900) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? anchoEfectivo() < breakpoint : false
  )
  useEffect(() => {
    const onResize = () => setIsMobile(anchoEfectivo() < breakpoint)
    window.addEventListener('resize', onResize)
    window.addEventListener('biango:zoom', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
      window.removeEventListener('biango:zoom', onResize)
    }
  }, [breakpoint])
  return isMobile
}
